import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Default translations (fallback if API fails)
const defaultTranslations = {
  el: {
    home: 'Αρχική',
    leaderboard: 'Κατάταξη',
    scores: 'Σκορ',
    partners: 'Συμπαίκτες',
    rules: 'Κανόνες',
    admin: 'Διαχείριση',
    login: 'Σύνδεση',
    logout: 'Αποσύνδεση',
    loading: 'Φόρτωση...',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    edit: 'Επεξεργασία',
    add: 'Προσθήκη',
    close: 'Κλείσιμο',
    search: 'Αναζήτηση',
    actions: 'Ενέργειες',
    viewAll: 'Προβολή Όλων',
    viewFullLeaderboard: 'Προβολή Πλήρους Κατάταξης',
    viewAllScores: 'Προβολή Όλων των Σκορ',
    rank: 'Θέση',
    player: 'Παίκτης',
    points: 'Πόντοι',
    points: 'Πόντοι',
    pts: 'Π',
    gamesDiff: 'GD',
    gamesDiffFull: 'Διαφ. Games',
    matches: 'Αγώνες',
    wins: 'Νίκες',
    winsShort: 'Ν',
    losses: 'Ήττες',
    lossesShort: 'Η',
    uniquePartners: 'Συμπ.',
    uniquePartnersFull: 'Μον. Συμπαίκτες',
    noPlayers: 'Δεν υπάρχουν παίκτες ακόμα',
    matchHistory: 'Ιστορικό Αγώνων',
    teamA: 'Ομάδα Α',
    teamB: 'Ομάδα Β',
    sets: 'Σετ',
    winner: 'Νικητής',
    noMatches: 'Δεν υπάρχουν αγώνες ακόμα',
    latestScores: 'Τελευταία Σκορ',
    partnersTracking: 'Παρακολούθηση Συμπαικτών',
    partnersDesc: 'Δείτε ποιοι παίκτες έχουν παίξει μαζί',
    matchesTogether: 'αγώνες μαζί',
    noPartnersYet: 'Δεν υπάρχουν συνεργασίες ακόμα',
    playedWith: 'Έπαιξε με',
    notPlayedWith: 'Δεν έπαιξε ακόμα με',
    fullRotation: 'Ολοκλήρωσε όλους τους συμπαίκτες',
    rotateForMatrix: 'Περιστρέψτε για Partner Matrix',
    gamesPlayed: 'αγώνες',
    currentMonth: 'Τρέχων Μήνας',
    daysRemaining: 'μέρες απομένουν',
    dayRemaining: 'μέρα απομένει',
    topPlayers: 'Top 3 Παίκτες',
    onFire: 'On Fire',
    winStreak: 'σερί νίκες',
    rulesTitle: 'Κανόνες Ladder',
    rulesIntro: 'Ο ladder τρέχει κάθε μήνα. Οι παίκτες παίζουν αγώνες ελεύθερα και τα αποτελέσματα καταγράφονται από τους διαχειριστές.',
    scoringRules: 'Βαθμολογία',
    winPoints: 'Νίκη = 2 πόντοι',
    lossPoints: 'Ήττα = 1 πόντος',
    partnerBonus: 'Μοναδικός συμπαίκτης = +1 πόντος (μία φορά ανά συμπαίκτη ανά μήνα)',
    tiebreaker: 'Ισοβαθμία',
    tiebreakerDesc: 'Σε περίπτωση ισοβαθμίας, η κατάταξη καθορίζεται από τη διαφορά games (κερδισμένα - χαμένα).',
    matchFormat: 'Μορφή Αγώνων',
    matchFormatDesc: '4 παίκτες (2 vs 2). Τουλάχιστον 1 σετ. Καταγραφή σκορ ανά σετ.',
    dashboard: 'Πίνακας Ελέγχου',
    players: 'Παίκτες',
    matchEntry: 'Καταχώρηση Αγώνα',
    settings: 'Ρυθμίσεις',
    translations: 'Μεταφράσεις',
    addPlayer: 'Προσθήκη Παίκτη',
    playerName: 'Όνομα Παίκτη',
    email: 'Email',
    phone: 'Τηλέφωνο',
    submitMatch: 'Υποβολή Αγώνα',
    selectPlayer: 'Επιλέξτε παίκτη',
    setScores: 'Σκορ Σετ',
    addSet: 'Προσθήκη Σετ',
    removeSet: 'Αφαίρεση Σετ',
    date: 'Ημερομηνία',
    court: 'Γήπεδο',
    comments: 'Σχόλια',
    ladderName: 'Όνομα Ladder',
    clubLogo: 'Λογότυπο Club',
    uploadLogo: 'Ανέβασμα Λογοτύπου',
    resetLadder: 'Επαναφορά Ladder',
    resetLadderDesc: 'Ξεκινήστε νέο μήνα. Οι παίκτες θα διατηρηθούν, τα αποτελέσματα θα μηδενιστούν.',
    resetConfirm: 'Είστε σίγουροι; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    adminLogin: 'Σύνδεση Διαχειριστή',
    password: 'Κωδικός',
    loginButton: 'Είσοδος',
    registerButton: 'Εγγραφή',
    name: 'Όνομα',
    invalidCredentials: 'Λάθος στοιχεία σύνδεσης',
    success: 'Επιτυχία',
    error: 'Σφάλμα',
    playerAdded: 'Ο παίκτης προστέθηκε',
    playerUpdated: 'Ο παίκτης ενημερώθηκε',
    playerDeleted: 'Ο παίκτης διαγράφηκε',
    matchAdded: 'Ο αγώνας καταχωρήθηκε',
    matchUpdated: 'Ο αγώνας ενημερώθηκε',
    matchDeleted: 'Ο αγώνας διαγράφηκε',
    settingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν',
    ladderReset: 'Ο ladder επαναφέρθηκε για τον νέο μήνα',
    translationsSaved: 'Οι μεταφράσεις αποθηκεύτηκαν',
    noLadder: 'Δεν υπάρχει ενεργός ladder',
    createLadder: 'Δημιουργία Ladder',
    poweredBy: 'Powered by',
    totalPlayers: 'Συνολικοί Παίκτες',
    totalMatches: 'Συνολικοί Αγώνες',
    thisMonth: 'Αυτόν τον Μήνα',
    months: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 
             'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
    // Career Stats & Achievements
    theHunted: 'Ο Κυνηγημένος',
    defendingChampion: 'Defending Champion',
    currentPeriod: 'Τρέχουσα Περίοδος',
    career: 'Καριέρα',
    achievements: 'Επιτεύγματα',
    careerStats: 'Στατιστικά Καριέρας',
    titles: 'Τίτλοι',
    runnerUps: 'Δεύτερες Θέσεις',
  },
  en: {
    home: 'Home',
    leaderboard: 'Leaderboard',
    scores: 'Scores',
    partners: 'Partners',
    rules: 'Rules',
    admin: 'Admin',
    login: 'Login',
    logout: 'Logout',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    search: 'Search',
    actions: 'Actions',
    viewAll: 'View All',
    viewFullLeaderboard: 'View Full Leaderboard',
    viewAllScores: 'View All Scores',
    rank: 'Rank',
    player: 'Player',
    points: 'Points',
    pts: 'P',
    gamesDiff: 'GD',
    gamesDiffFull: 'Game Diff',
    matches: 'Matches',
    wins: 'Wins',
    winsShort: 'W',
    losses: 'Losses',
    lossesShort: 'L',
    uniquePartners: 'Part.',
    uniquePartnersFull: 'Unique Partners',
    noPlayers: 'No players yet',
    matchHistory: 'Match History',
    teamA: 'Team A',
    teamB: 'Team B',
    sets: 'Sets',
    winner: 'Winner',
    noMatches: 'No matches yet',
    latestScores: 'Latest Scores',
    partnersTracking: 'Partners Tracking',
    partnersDesc: 'See which players have partnered together',
    matchesTogether: 'matches together',
    noPartnersYet: 'No partnerships yet',
    playedWith: 'Played with',
    notPlayedWith: 'Not played with yet',
    fullRotation: 'Full partner rotation completed',
    rotateForMatrix: 'Rotate for Partner Matrix',
    gamesPlayed: 'games',
    currentMonth: 'Current Month',
    daysRemaining: 'days remaining',
    dayRemaining: 'day remaining',
    topPlayers: 'Top 3 Players',
    onFire: 'On Fire',
    winStreak: 'win streak',
    rulesTitle: 'Ladder Rules',
    rulesIntro: 'The ladder runs monthly. Players play matches freely and results are recorded by admins.',
    scoringRules: 'Scoring',
    winPoints: 'Win = 2 points',
    lossPoints: 'Loss = 1 point',
    partnerBonus: 'Unique partner = +1 point (once per partner per month)',
    tiebreaker: 'Tiebreaker',
    tiebreakerDesc: 'In case of a tie, ranking is determined by game difference (games won - games lost).',
    matchFormat: 'Match Format',
    matchFormatDesc: '4 players (2 vs 2). At least 1 set. Score recorded per set.',
    dashboard: 'Dashboard',
    players: 'Players',
    matchEntry: 'Match Entry',
    settings: 'Settings',
    translations: 'Translations',
    addPlayer: 'Add Player',
    playerName: 'Player Name',
    email: 'Email',
    phone: 'Phone',
    submitMatch: 'Submit Match',
    selectPlayer: 'Select player',
    setScores: 'Set Scores',
    addSet: 'Add Set',
    removeSet: 'Remove Set',
    date: 'Date',
    court: 'Court',
    comments: 'Comments',
    ladderName: 'Ladder Name',
    clubLogo: 'Club Logo',
    uploadLogo: 'Upload Logo',
    resetLadder: 'Reset Ladder',
    resetLadderDesc: 'Start a new month. Players will be kept, results will be reset.',
    resetConfirm: 'Are you sure? This action cannot be undone.',
    adminLogin: 'Admin Login',
    password: 'Password',
    loginButton: 'Sign In',
    registerButton: 'Register',
    name: 'Name',
    invalidCredentials: 'Invalid credentials',
    success: 'Success',
    error: 'Error',
    playerAdded: 'Player added',
    playerUpdated: 'Player updated',
    playerDeleted: 'Player deleted',
    matchAdded: 'Match recorded',
    matchUpdated: 'Match updated',
    matchDeleted: 'Match deleted',
    settingsSaved: 'Settings saved',
    ladderReset: 'Ladder reset for new month',
    translationsSaved: 'Translations saved',
    noLadder: 'No active ladder',
    createLadder: 'Create Ladder',
    poweredBy: 'Powered by',
    totalPlayers: 'Total Players',
    totalMatches: 'Total Matches',
    thisMonth: 'This Month',
    months: ['January', 'February', 'March', 'April', 'May', 'June',
             'July', 'August', 'September', 'October', 'November', 'December'],
    // Career Stats & Achievements
    theHunted: 'The Hunted',
    defendingChampion: 'Defending Champion',
    currentPeriod: 'Current Period',
    career: 'Career',
    achievements: 'Achievements',
    careerStats: 'Career Stats',
    titles: 'Titles',
    runnerUps: 'Runner-Ups',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('padel-ladder-lang');
    return saved || 'el';
  });
  const [translations, setTranslations] = useState(defaultTranslations);
  const [translationsLoaded, setTranslationsLoaded] = useState(false);

  // Fetch translations from API
  const fetchTranslations = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/translations`);
      if (res.ok) {
        const data = await res.json();
        // Merge with defaults to ensure all keys exist
        setTranslations({
          el: { ...defaultTranslations.el, ...data.el },
          en: { ...defaultTranslations.en, ...data.en }
        });
      }
    } catch (error) {
      console.error('Failed to fetch translations, using defaults:', error);
    } finally {
      setTranslationsLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchTranslations();
  }, [fetchTranslations]);

  useEffect(() => {
    localStorage.setItem('padel-ladder-lang', language);
  }, [language]);

  const t = useCallback((key) => {
    return translations[language]?.[key] || defaultTranslations[language]?.[key] || key;
  }, [translations, language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'el' ? 'en' : 'el');
  }, []);

  // Expose refresh function for admin to update translations
  const refreshTranslations = useCallback(async () => {
    await fetchTranslations();
  }, [fetchTranslations]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    toggleLanguage,
    t,
    translations,
    translationsLoaded,
    refreshTranslations
  }), [language, toggleLanguage, t, translations, translationsLoaded, refreshTranslations]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
